import { type SerializedCompStructure } from '@wix/document-services-types'

import {
  type DataBindingController,
  type DataBindingControllerConnection,
} from '../types'
import { assertNonNullable } from './assertNonNullable'
import { doesControllerHaveConnectionsToComponent } from './doesControllerHaveConnectionsToComponent'
import { getControllerConnectionsToComponent } from './getControllerConnectionsToComponent'
import { getVeloIdOf } from './getVeloIdOf'

export const breakDownControllerConnectionsToComponent = ({
  controller,
  component,
}: {
  controller: DataBindingController
  component: SerializedCompStructure
}): {
  controllerConnectionsByVeloId: {
    [VeloId: string]: DataBindingControllerConnection[]
  }
  connectedComponentIds: string[]
} => {
  assertNonNullable(component.id)
  const componentId = component.id
  const breakdown: ReturnType<
    typeof breakDownControllerConnectionsToComponent
  > = doesControllerHaveConnectionsToComponent({
    controller,
    componentId,
  })
    ? {
        controllerConnectionsByVeloId: {
          [getVeloIdOf(component)]: getControllerConnectionsToComponent({
            controller,
            componentId,
          }),
        },
        connectedComponentIds: [componentId],
      }
    : {
        controllerConnectionsByVeloId: {},
        connectedComponentIds: [],
      }

  return component.components !== undefined
    ? component.components.reduce(
        (
          { controllerConnectionsByVeloId, connectedComponentIds },
          component,
        ) => {
          const subBreakdown = breakDownControllerConnectionsToComponent({
            component,
            controller,
          })
          return {
            controllerConnectionsByVeloId: {
              ...controllerConnectionsByVeloId,
              ...subBreakdown.controllerConnectionsByVeloId,
            },
            connectedComponentIds: [
              ...connectedComponentIds,
              ...subBreakdown.connectedComponentIds,
            ],
          }
        },
        breakdown,
      )
    : breakdown
}
